module.exports = __webpack_public_path__ + "img/logo-emeraude-solaire.8368cb18.jpeg";